import React from 'react';
import classnames from 'classnames';

function ModalFormCategoryBadge({ badge, className, onClick }) {
  if (badge?.text == null) {
    return null;
  }

  return (
    <span
      onClick={onClick}
      className={classnames(
        'modalFormCategoryLayout__navBadge',
        {
          'modalFormCategoryLayout__navBadge--default':
            !badge.variant || badge.variant === 'default',
          'modalFormCategoryLayout__navBadge--doing':
            badge.variant === 'doing',
          'modalFormCategoryLayout__navBadge--done': badge.variant === 'done',
        },
        className
      )}
    >
      {badge.text}
    </span>
  );
}

export default ModalFormCategoryBadge;
